"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personaIdList = void 0;
var personaIdList = {
  '101': '101',
  '102': '102',
  '103': '103',
  '104': '104',
  '105': '105',
  '106': '106',
  '107': '107',
  '108': '108',
  '109': '109',
  '110': '110',
  '111': '111',
  '112': '112',
  '113': '113',
  '201': '201',
  '202': '202',
  '203': '203',
  '204': '204',
  '205': '205',
  '206': '206',
  '207': '207',
  '208': '208',
  '209': '209',
  '210': '210',
  '301': '301',
  '302': '302',
  '303': '303',
  '304': '304',
  '305': '305',
  '306': '306',
  '307': '307',
  '401': '401',
  '402': '402',
  '403': '403',
  '404': '404',
  '405': '405',
  '406': '406',
  '407': '407',
  '408': '408',
  '409': '409',
  '501': '501',
  '502': '502',
  '503': '503',
  '504': '504',
  '505': '505',
  '506': '506',
  '507': '507',
  '508': '508',
  '601': '601',
  '602': '602',
  '603': '603',
  '604': '604',
  '605': '605',
  '606': '606',
  '607': '607',
  '701': '701'
};
exports.personaIdList = personaIdList;